export const getCurrency = (price: number = 0) =>
  `${Math.ceil(price / 100)} MDL`;
